import React, {Component} from 'react';
import {Modal, ModalHeader} from 'reactstrap';
import {ReconnectAdAccountForm} from "./ReconnectAdAccountForm";
import {Translation} from 'react-i18next';

export class ReconnectAdAccountModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
        };

        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        if (this.props.onToggle) {
            this.props.onToggle();
        } else {
            this.setState({
                modal: !this.state.modal
            });
        }
    }

    isOpen() {
        if (this.props.isOpen !== undefined) {
            return this.props.isOpen;
        }
        return this.state.modal;
    }

    render() {
        const name = this.props.adAccountData && this.props.adAccountData.name;
        return (
            // `reconnect-account-dialog`: a 390 el modal deja 16 px a cada lado (`_reconnect-account.scss`).
            <Modal isOpen={this.isOpen()} toggle={this.toggle} backdrop="static"
                   className={[this.props.className, 'reconnect-account-dialog'].filter(Boolean).join(' ')}>
                <ModalHeader toggle={this.toggle}>
                    {/* El nombre es dato: sin `escapeValue: false`, «Óptica / Black» salía con `&#x2F;`. */}
                    <Translation>{(t) => t('reconnect_modal.title', { name, interpolation: { escapeValue: false } })}</Translation>
                </ModalHeader>
                <ReconnectAdAccountForm
                    adAccountData={this.props.adAccountData}
                    onReconnected={this.props.onReconnected}
                    onToggle={this.toggle}
                />
            </Modal>
        );
    }
}
